// constants.js
import QuizPlatform from "./QuizPlatform.json";

export const ABI = QuizPlatform.abi;
export const CONTRACT_ADDRESS = "0xAcc0993377b716f4C9814751fb64022247427eF9"; // Replace with your contract address
